import React, { useEffect, useState } from 'react';
import { Box, Flex } from '@qga/roo-ui/components';

import Disclosure from '@/components/Disclosure';
import Text from '@/components/Text';
import { viewPointAccordionDetailsDataLayerEvent } from '@/v2/components/pages/CampaignView/utils/dataLayer';

export const accordionData = [
  'Book any Jetstar Holidays package between 23 - 30 April 2025. There is no minimum spend for this promotion.',
  'Simply add your Qantas Frequent Flyer number to Traveller details when completing a booking.',
  "Points will be credited to your account within 8 weeks after you've checked out of your hotel.",
  'Did you know - you can save your money and use Qantas Points Plus Pay on Jetstar Flights, Jetstar Holidays and Hotels.',
];

const PointAccordion = ({ headerTitle }: { headerTitle: string }) => {
  const [open, setOpen] = useState<Boolean>(false);

  useEffect(() => {
    if (open) {
      viewPointAccordionDetailsDataLayerEvent(
        'Deals page',
        'How do I earn Qantas points?',
      );
    }
  }, [open]);

  return (
    <Box
      onClick={() => {
        setOpen((preState) => !preState);
      }}
    >
      <Disclosure
        isSmallTitle
        headerTitle={headerTitle}
        expand={open}
        variant="default"
        containerStyles={{
          border: '1px solid',
          borderRadius: '8px',
          px: 4,
        }}
        headerStyles={{
          fontSize: ['sm', null, 'base'],
          pt: 3,
          pb: 2,
        }}
      >
        <Box>
          <Flex flexDirection="column" gap={4}>
            {accordionData.map((faq, index) => (
              <Flex
                alignItem="flex-start"
                gap={3}
                key={index}
                data-testid={`point-accordion-${index}`}
              >
                <Flex
                  minWidth={24}
                  height={24}
                  border="1px solid"
                  borderColor="brand.primary"
                  borderRadius="50%"
                  justifyContent="center"
                  alignItem="center"
                >
                  <Text color="brand.primary" fontWeight="500">
                    {index + 1}
                  </Text>
                </Flex>
                <Text>{faq}</Text>
              </Flex>
            ))}
          </Flex>
        </Box>
      </Disclosure>
    </Box>
  );
};

export default PointAccordion;
